import React from "react";
import "../index.css"; // Import the CSS file for styling

export default function AboutSection() {
  return (
    <section className="page-about py-5">
      <div className="container">
        <div className="row align-items-center g-5">

          {/* Left Side Images */}
          <div className="col-lg-6">
            <div className="about-image-wrapper">

              <div className="main-image">
                <img
                  src="/assets/images/page-about-1.jpg"
                  alt="About HealthTech"
                  className="img-fluid rounded-4 shadow-lg"
                />
              </div>

              <div className="floating-image">
                <img
                  src="/assets/images/page-about-1.jpg"
                  alt="HealthTech Solutions"
                  className="img-fluid rounded-4 shadow"
                />
              </div>

              <div className="experience-badge">
                <h3>2025</h3>
                <span>Founded</span>
              </div>

            </div>
          </div>

          {/* Right Side Content */}
          <div className="col-lg-6">
            <div className="about-content">

              <span className="section-tag">
                About HealthTech Solutions
              </span>

              <h2 className="display-6 fw-bold mb-4">
                AI-Enabled IT & Digital Solutions for Healthcare & Pharma
              </h2>

              <p className="lead text-muted">
                Founded in 2025, HealthTech Solutions delivers innovative
                digital transformation services across healthcare,
                pharmaceutical, life sciences, and technology sectors.
              </p>

              <p>
                We empower organizations through advanced software
                development, AI-powered automation, cloud solutions,
                digital marketing, and strategic consulting.
              </p>

              <p>
                Our mission is to help businesses become smarter,
                scalable, and future-ready through technology-driven
                innovation.
              </p>

              <div className="row mt-4">
                <div className="col-6">
                  <div className="feature-box">
                    ✓ AI Solutions
                  </div>
                </div>

                <div className="col-6">
                  <div className="feature-box">
                    ✓ Cloud Services
                  </div>
                </div>

                <div className="col-6 mt-3">
                  <div className="feature-box">
                    ✓ Digital Marketing
                  </div>
                </div>

                <div className="col-6 mt-3">
                  <div className="feature-box">
                    ✓ Software Development
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}